export const isWholeNumber = (s: string) =>
  s.replace(new RegExp('^0+(?!$)'), '') === String(parseInt(s, 10));

export const replaceAt = (value: string, index: number, replacement: string) =>
  value.substring(0, index) +
  replacement +
  value.substring(index + replacement.length);

export const getFullName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  patronymic?: string | null
) => {
  let fullName = lastName || '';

  if (firstName) {
    fullName += ` ${firstName}`;
  }

  if (patronymic) {
    fullName += ` ${patronymic}`;
  }

  return fullName.trim();
};

export function generateRandomString(length: number) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const generateCryptoSecurePassword = (
  length = 16,
  useUppercase = true,
  useNumbers = true,
  useSpecialChars = true
): string => {
  const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
  const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numberChars = '0123456789';
  const specialChars = '!@#$%^&*()_+~`|}{[]:;?><,./-=';

  const availableChars = [
    lowercaseChars,
    useUppercase && uppercaseChars,
    useNumbers && numberChars,
    useSpecialChars && specialChars,
  ]
    .filter(Boolean)
    .join('');

  const getRandomChar = (randomValue: number): string =>
    availableChars[randomValue % availableChars.length];

  const getRandomValues = (): Uint32Array => {
    const array = new Uint32Array(length);
    crypto.getRandomValues(array);
    return array;
  };

  return Array.from(getRandomValues()).map(getRandomChar).join('');
};

export const getWordDeclension = (word: string, total: number): string => {
  const remainder10 = total % 10;
  const remainder100 = total % 100;

  if (remainder100 >= 11 && remainder100 <= 19) return `${word}ов`;
  if (remainder10 === 1) return word;
  if (remainder10 >= 2 && remainder10 <= 4) return `${word}а`;
  return `${word}ов`;
};
